// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__TZDHl","title":"ClientInsurance_title__1VRMT","itemText":"ClientInsurance_itemText__1qDec"};